import { render, staticRenderFns } from "./ExpandedIcon.vue?vue&type=template&id=6fc2800a&scoped=true&"
import script from "./ExpandedIcon.vue?vue&type=script&lang=js&"
export * from "./ExpandedIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedIcon.vue?vue&type=style&index=0&id=6fc2800a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2800a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
